import { ToolbarButton } from '../ToolbarButton'
import { Trash2 } from 'blaze-ui/icons'
import { useActions } from 'components/VisualStudioPlayground/VisualEditor/hooks/useActions'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

type Props = {
  withText?: boolean
}

const DeleteButton = ({ withText = true }: Props) => {
  const actions = useActions()
  const { isMobile } = useResponsiveDesign()

  return (
    <ToolbarButton title="Delete" frontIcon={Trash2} onPress={() => actions.delete.onSelect()}>
      {!isMobile && withText && 'Delete'}
    </ToolbarButton>
  )
}

export { DeleteButton }
